import React, { useState } from 'react'
import { Button, Modal, SelectAsync, TextArea } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import debounce from 'debounce-promise'
import { useIntl } from 'react-intl'
import messages from './messages'

export default NiceModal.create(({checkedTasks}) => {
  const modal = useModal()
  const [loading, setLoading] = useState(false)
  const [selectedProducer, setSelectedProducer] = useState(null) 
  const [message, setMessage] = useState('')
  const { formatMessage } = useIntl()

  if (!checkedTasks) {
    return null
  }

  const onSubmit = () => {
    setLoading(true)
    const body = new FormData()
    body.append('taskIds', checkedTasks)
    body.append('supplierId', selectedProducer)
    body.append('msg', message)
    fetch(`/ordertask/assignSupplierToTaskIds.json`, { method: 'POST', body})
      .then(() => {
        toastr.success(formatMessage(messages.successToastr))
      })
      .catch((error) => toastr.error(error))
      .finally(() => {
        setLoading(false)
        modal.resolve()
        modal.remove()
        reactHistory.push('/reload-dashboard')
      })
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => loading ? undefined : onSubmit()}
      title={`${formatMessage(messages.modalTitle)}`}
      dialogPanelClasses="overflow-x-scroll"
    >
      <div className="space-y-4">
        <SelectAsync
          onChange={(selection) => setSelectedProducer(selection.value)}
          options={[]}
          label={formatMessage(messages.producerSelect)}
          noOptionsMessage={() => formatMessage(messages.noProducerFound)}
          cacheOptions
          defaultOptions
          loadOptions={
            debounce((query) => fetch(`/rest/v2/supplier?search[type]=3&search[name]=${query}`)
              .then((response) => response.json())
              .then((producers) => producers.map(({ uid, firstname, lastname, userid }) => ({ value: uid, label: `${firstname} ${lastname} | ${userid}` })))
            , 250)
          }
        />
        <TextArea
          label={formatMessage(messages.textAreaLabel)}
          rows={6}
          value={message}
          onChange={({ target: { value } }) => setMessage(value)}
        />
      </div>
      <div className='text-right mt-4'>
        <Button onClick={() => onSubmit()} disabled={loading} >
          {loading ? 'Loading' : formatMessage(messages.submitButton)}
        </Button>
      </div>
    </Modal>
  )
})
